<template>
    <div id="app" class="page-wrapper">
        <div class="wrapper" v-if="!isPhone" >
            <div class="titleWrapper">
                <img class="logo" src="../assets/img/rumor-logo.png" alt="">
                <h1 class="title">谣言鉴别</h1>
            </div>
            <div class="description">快速鉴别新闻事件信息真伪</div>
            <div>
                <div class="infoLabel">服务介绍</div>
                <div>
                    <article>
                        <h2>什么是谣言鉴别 MCP 服务？</h2>
                        <p>开发者可以通过谣言鉴别MCP Server快速鉴别新闻事件信息真伪。</p>
                        <h2>如何使用谣言鉴别MCP 服务？</h2>
                        <p>我们已为您部署好了云端的谣言鉴别MCP Server 服务，您需要邮件联系seven@thecover.co获取账号凭证Key。目前 MCP 服务已支持添加到智能体和工作流中。</p>
                        <p>如您需要切换API KEY，可取消开通后重新填入。</p>
                        <h2>谣言鉴别MCP 服务的关键特性</h2>
                        <p>谣言鉴别MCP Server结合大模型的深度语义理解能力、权威谣言知识库及多维度验证策略，提供高准确率的谣言检测结果，适用于内容审核、舆情监控、社交媒体治理等场景。</p>
                        <h2>谣言鉴别 MCP 服务的使用案例</h2>
                        <p>
                            <img src="../assets/img/rumor-1.png" alt="">
                        </p>
                        <h2>常见问题解答</h2>
                        <p>Q：使用谣言鉴别 MCP 服务是否需要付费？</p>
                        <p>A：免费。</p>
                        <p>Q：账号凭证Key如何申请</p>
                        <p>A：通过邮件联系seven@thecover.co获取账号凭证Key</p>
                        <p>Q：谣言鉴别 MCP Server返回的数据格式？</p>
                        <p>A：为方便开发者接入，谣言鉴别 MCP Server返回的数据为json格式化的数据。</p>
                        <p>示例：</p>
                        <p>
                            <span>{</span>
                            <span>"identify": true, // 是否甄别为谣言</span>
                            <span>"url": "https://xxx", // 辟谣来源网址</span>
                            <span>"title": "文章标题", // 辟谣来源文章标题</span>
                            <span>"description": "描述信息" // 甄别结果描述</span>
                            <span>}</span>
                        </p>
                        <!-- <p style="margin-top: 3rem;">重要提醒：</p>
                        <p>该MCP服务由第三方提供，可能涉及数据传输至第三方服务器。请在集成前评估其安全性，并确认已同意相关协议。阿里云百炼平台不对数据传输或第三方行为负责。</p> -->
                    </article>
                </div>
            </div>
        </div>
        <div class="wrapper" v-if="isPhone" >
            <div class="titleWrapper">
                <img class="logo" src="../assets/img/rumor-logo.png" alt="">
                <h1 class="title">谣言鉴别</h1>
            </div>
            <div class="description">快速鉴别新闻事件信息真伪</div>
            <div>
                <div class="infoLabel">服务介绍</div>
                <div>
                    <article>
                        <h2>什么是谣言鉴别 MCP 服务？</h2>
                        <p>开发者可以通过谣言鉴别MCP Server快速鉴别新闻事件信息真伪。</p>
                        <h2>如何使用谣言鉴别MCP 服务？</h2>
                        <p>我们已为您部署好了云端的谣言鉴别MCP Server 服务，您需要邮件联系seven@thecover.co获取账号凭证Key。目前 MCP 服务已支持添加到智能体和工作流中。</p>
                        <p>如您需要切换API KEY，可取消开通后重新填入。</p>
                        <h2>谣言鉴别MCP 服务的关键特性</h2>
                        <p>谣言鉴别MCP Server结合大模型的深度语义理解能力、权威谣言知识库及多维度验证策略，提供高准确率的谣言检测结果，适用于内容审核、舆情监控、社交媒体治理等场景。</p>
                        <h2>谣言鉴别 MCP 服务的使用案例</h2>
                        <p>
                            <img src="../assets/img/rumor-1.png" alt="">
                        </p>
                        <h2>常见问题解答</h2>
                        <p>Q：使用谣言鉴别 MCP 服务是否需要付费？</p>
                        <p>A：免费。</p>
                        <p>Q：账号凭证Key如何申请</p>
                        <p>A：通过邮件联系seven@thecover.co获取账号凭证Key</p>
                        <p>Q：谣言鉴别 MCP Server返回的数据格式？</p>
                        <p>A：为方便开发者接入，谣言鉴别 MCP Server返回的数据为json格式化的数据。</p>
                        <p>示例：</p>
                        <p>
                            <span>{</span>
                            <span>"identify": true, // 是否甄别为谣言</span>
                            <span>"url": "https://xxx", // 辟谣来源网址</span>
                            <span>"title": "文章标题", // 辟谣来源文章标题</span>
                            <span>"description": "描述信息" // 甄别结果描述</span>
                            <span>}</span>
                        </p>
                        <!-- <p style="margin-top: 3rem;">重要提醒：</p>
                        <p>该MCP服务由第三方提供，可能涉及数据传输至第三方服务器。请在集成前评估其安全性，并确认已同意相关协议。阿里云百炼平台不对数据传输或第三方行为负责。</p> -->
                    </article>
                </div>
            </div>
        </div>
        <GoHome v-if="isPhone" />
    </div>
</template>
<script>
import NewsList from '@/components/NewsList'
import { mapState, mapMutations } from 'vuex'
import GoHome from '@/components/GoHome.vue';
export default {
    name: 'Search',
    data() {
        return {
            
        }
    },
    components: {
        NewsList,
        GoHome
    },
    created() {
        // 获取列表数据
        document.title = "四川互联网举报辟谣平台";
        this.keyword = this.$route.query.keyword || '';
        this.setInit();
        this.setIsSubject(true);
        this.setIsSpecial(-1)
    },
    mounted() {
        this.isPhone && this.$Common.onShare({
            shareTitle: '四川互联网举报辟谣平台',
            shareUrl: window.location.href,
            shareBrief: '四川互联网举报辟谣平台',
            shareImg: 'https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/piyao_share_logo.png?version=v1',
        })
    },
    methods: {
        ...mapMutations(['setIsSpecial', 'setLoadingShow', 'setIsSubject']),
        
        setInit() {
            this.setLoadingShow(false)

        },
        setLoading() {
            this.setLoadingShow(false);
 
        },

    },

    computed: {
        // ...mapState(['freshSearchFlag']),
        isPhone() {
            return this.$Common.Attribute.isMb()
        },
    }
}
</script>
<style lang="less" scoped>


.pc-wrapper {
    .wrapper {
        
        .titleWrapper {
            align-items: center;
            margin-bottom: 0.4rem;
            display: flex;
            .logo {
                object-fit: contain;
                border-radius: 0.4rem;
                width: 2.5rem;
                height: 2.5rem;
                margin-right: 0.6rem;
            }
            .title {
                color: var(--efm_ant-color-text-base);
                font-size: 1.5rem;
                font-weight: 500;
            }
        }
        .description{
            color: rgba(38, 36, 76, 0.65);
            font-size: 1rem;
        }
        .infoLabel{
            margin-top: 2rem;
            font-size: 1rem;
            margin-bottom: 0.8rem;
        }
        article{
            h2{
                font-size: 1.2rem;
                margin-bottom: 0.8rem;
            }
            p{
                font-size: 1rem;
                margin-bottom: 0.8rem;
                img{
                    max-width: 100%;
                    height: auto;
                }
                span{
                    display: block;
                    font-size: 1rem;
                    line-height: 1.6;
                }
            }
        }
    }
}
.wap-wrapper {
    .wrapper {
        padding: 2rem;
        .titleWrapper {
            align-items: center;
            margin-bottom: 0.4rem;
            display: flex;
            .logo {
                object-fit: contain;
                border-radius: 0.4rem;
                width: 2.5rem;
                height: 2.5rem;
                margin-right: 0.6rem;
            }
            .title {
                color: var(--efm_ant-color-text-base);
                font-size: 1.5rem;
                font-weight: 500;
            }
        }
        .description{
            color: rgba(38, 36, 76, 0.65);
            font-size: 1rem;
        }
        .infoLabel{
            margin-top: 2rem;
            font-size: 1rem;
            margin-bottom: 0.8rem;
        }
        article{
            h2{
                font-size: 1.2rem;
                margin-bottom: 0.8rem;
            }
            p{
                font-size: 1rem;
                margin-bottom: 0.8rem;
                img{
                    max-width: 100%;
                    height: auto;
                }
                span{
                    display: block;
                    font-size: 1rem;
                    line-height: 1.6;
                }
            }
        }
    }
}
</style>